// ----------------------------------------------------------------------------
// Component: HP Sustainability Component
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Odometer from './odometer';

// -------------------------------------
// Styles
// -------------------------------------
import './_hp-sustainability.scss';
import './_odometer.scss';

// -------------------------------------
// Main
// -------------------------------------
const HP_SECTION            = '.hp-sustainability';
const HP_STATS_WRAPPER      = '.hp-sustainability__stats-wrapper';

const STATS_BLOCKS          = '.hp-sustainability__stats-block';
const STAT_BLOCK_PERCENTAGE = '.hp-sustainability__percentage .hp-sustainability__percentage-number';

const HP_SECTION_ELEMENTS   = document.querySelectorAll(HP_SECTION);

// Check if there are any hp-sustainability sections
if (HP_SECTION_ELEMENTS.length > 0) {
  HP_SECTION_ELEMENTS.forEach((hpSection)=> {
    const statsWrapper = hpSection.querySelector(HP_STATS_WRAPPER);
    const statBlocks = statsWrapper.querySelectorAll(STATS_BLOCKS);
    
    // Check if there are any valid stat blocks
    if (statBlocks.length > 0) {
      // Apply Odometer to each percentage value
      statBlocks.forEach((stat_block, index) => {
        let blockTrigger = false;
          
        window.addEventListener('scroll', () => { 
          const statsTop = statsWrapper.offsetTop;
          
          //Check if animation has been trigger and if the stat section is in view
          if (!blockTrigger && window.pageYOffset > statsTop) {
            const percentageBlock = stat_block.querySelector(STAT_BLOCK_PERCENTAGE);
            const countTo = percentageBlock.getAttribute('data-percentage');
            
            new Odometer({
                el: percentageBlock,
                value: 0,
                format: '',
                theme: 'default',
                duration: 3000,
            });
            
            percentageBlock.innerHTML = (countTo);
            blockTrigger = true;
          }
        });
      });
    } 
  });
}